import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import hero480 from '@/assets/hero/hero-480.webp.asset.json';
import hero768 from '@/assets/hero/hero-768.webp.asset.json';
import hero1200 from '@/assets/hero/hero-1200.webp.asset.json';
import hero1400 from '@/assets/hero/hero-1400.webp.asset.json';

const HeroVideo = () => {
  const heroSrcSet = `${hero480.url} 480w, ${hero768.url} 768w, ${hero1200.url} 1200w, ${hero1400.url} 1400w`;
  return (
    <section className="relative pt-[88px] lg:pt-[112px] w-full overflow-hidden cursor-plus">
      {/* Image Background - responsive aspect ratio so mobile stays short and desktop stays cinematic */}
      <div className="relative w-full aspect-[16/9] bg-[#0B0B0B]">
        <picture className="absolute inset-0">
          <source
            type="image/webp"
            srcSet={heroSrcSet}
            sizes="100vw"
          />
          <img
            src={hero1400.url}
            alt="Grizzlee Gripz New Look - Premium Pickleball Overgrips"
            className="absolute inset-0 w-full h-full object-contain object-center"
            loading="eager"
            fetchPriority="high"
            decoding="sync"
            width={1672}
            height={941}
          />
        </picture>
      </div>

      {/* Content */}
      <div className="absolute inset-0 pt-[88px] lg:pt-[112px] z-20 flex items-end justify-center text-center px-4 pb-6 md:pb-10 lg:pb-14">
        <div className="max-w-4xl">
          <h1 className="sr-only">
            Premium Pickleball Overgrips & Grip Spray
          </h1>

          <p className="sr-only">
            Comfort, Dry Feel, or XTREME Tack—match the grip to how you play.
          </p>
            
          <div
            className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center px-4"
            style={{
              animation: 'hero-fade-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.8s both',
              textShadow: '0 1px 2px rgba(0,0,0,0.85), 0 2px 6px rgba(0,0,0,0.7), 0 4px 16px rgba(0,0,0,0.55)',
            }}
          >
            <Link to="/grips/comfort">
              <Button size="lg" className="btn-fill-rise btn-fill-light font-display font-bold text-base md:text-lg px-6 md:px-10 py-5 md:py-7 rounded-full w-full sm:w-auto">
                Shop Overgrips
              </Button>
            </Link>
            <Link to="/grip-pro">
              <Button size="lg" variant="outline" className="btn-fill-rise btn-fill-light hover:!text-white font-display font-bold text-base md:text-lg px-6 md:px-10 py-5 md:py-7 rounded-full w-full sm:w-auto">
                Shop Grip Enhancer
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - CSS only */}
      <div
        className="absolute bottom-8 right-4 md:right-8 z-20"
        style={{ animation: 'hero-fade-up 0.6s ease 1s both' }}
      >
        <div
          className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2"
          style={{ animation: 'scroll-bounce 1.5s ease-in-out infinite' }}
        >
          <div className="w-1.5 h-3 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroVideo;